import PropTypes from 'prop-types';
import { NumericInput } from '@evertrue/et-components';

const NumberInput = ({ onChange, onBlur, name, value, required = false, field, meta, helpers, ...props }) => {
  return (
    <NumericInput
      onChange={(amount) => {
        onChange({ target: { name, value: amount } });
      }}
      onBlur={() => {
        onBlur({ target: { name } });
      }}
      value={value}
      {...props}
    />
  );
};

NumberInput.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.number,
  required: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    checked: PropTypes.bool,
    multiple: PropTypes.bool,
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
    initialError: PropTypes.string,
    initialTouched: PropTypes.bool,
    initialValue: PropTypes.any,
    touched: PropTypes.bool,
    value: PropTypes.any,
  }),
  helpers: PropTypes.shape({
    setValue: PropTypes.func,
    setTouched: PropTypes.func,
    setError: PropTypes.func,
  }),
};

export default NumberInput;
